import React from 'react';
import { useNavigate } from 'react-router-dom';
import PrimaryButton from '../../../Components/Buttons/PrimaryButton/PrimaryButton.component';
import NotFoundImg from '../../../Visuals/Images/NotFound.svg';
import { NotFoundContainer } from './NotFound.styles';
import HelmetHelper from '../../../Components/PageHelmet/HelmetHelper.component';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <NotFoundContainer>
      <HelmetHelper
        title="Not Found"
        description="Content has not been found"
      />
      <img src={NotFoundImg} alt="404 illustration" />
      <div>
        <h2>Sorry — this page cannot be found</h2>
        <p
          style={{
            color: 'var(--grey5)',
            maxWidth: 520,
            margin: 'var(--space-xs) auto var(--space-m)',
          }}
        >
          The link may be broken or the page may have moved. Try one of these
          quick actions to continue.
        </p>

        <div
          style={{
            display: 'flex',
            gap: 'var(--space-s)',
            marginTop: 'var(--space-m)',
            justifyContent: 'center',
            flexWrap: 'wrap',
          }}
        >
          <PrimaryButton
            functionName={() => navigate('/')}
            span="Return Home"
          />

          <button
            type="button"
            onClick={() => navigate('/login')}
            aria-label="Go to login"
            style={{
              background: 'transparent',
              border: '1.5px solid var(--grey2)',
              color: 'var(--grey7)',
              padding: 'var(--space-s) var(--space-m)',
              borderRadius: 'var(--borderRadiusButton)',
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            Login
          </button>

          <button
            type="button"
            onClick={() => navigate('/training')}
            aria-label="View online training"
            style={{
              background: 'linear-gradient(90deg,var(--blue3),var(--blue4))',
              border: 'none',
              color: 'white',
              padding: 'var(--space-s) var(--space-m)',
              borderRadius: 'var(--borderRadiusButton)',
              fontWeight: 700,
              cursor: 'pointer',
            }}
          >
            Online Training
          </button>
        </div>

        <div
          style={{
            marginTop: 'var(--space-m)',
            textAlign: 'center',
            color: 'var(--grey4)',
          }}
        >
          Check your URL for typos, or return to the homepage.
        </div>
      </div>
    </NotFoundContainer>
  );
};

export default NotFound;
